import { render, staticRenderFns } from "./right-bottom.vue?vue&type=template&id=20acf7c8&scoped=true"
import script from "./right-bottom.vue?vue&type=script&lang=js"
export * from "./right-bottom.vue?vue&type=script&lang=js"
import style0 from "./right-bottom.vue?vue&type=style&index=0&id=20acf7c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20acf7c8",
  null
  
)

export default component.exports